'use client';

import { Stack } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { FormEvent, useEffect, useState } from 'react';
import EmailInput, { TEmailInputProps } from './EmailInput';
import { CircularProgressButton } from './Form';

export type TEmailInputWithContinueButtonProps = {
  onSubmit: ({
    email,
    event,
  }: {
    email: string;
    event: FormEvent<HTMLFormElement>;
  }) => Promise<void>;
} & TEmailInputProps;

export default function EmailInputWithContinueButton({
  initialEmail,
  onEmailChange,
  onSubmit,
  isBusy,
  ...restEmailProps
}: Readonly<TEmailInputWithContinueButtonProps>) {
  const [email, setEmail] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    // The initialEmail may null at the first then it is populated a value,
    // thus we need to reset the email by the actual value
    setEmail(initialEmail || '');
  }, [initialEmail]);

  return (
    <Stack
      width="100%"
      component="form"
      onSubmit={(event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsSubmitting(true);
        onSubmit({ email, event });
      }}
      gap={tokens.spacingLg}
      alignItems="center"
    >
      <EmailInput
        {...restEmailProps}
        initialEmail={email}
        onEmailChange={(email) => {
          setEmail(email);
          onEmailChange?.(email);
        }}
        isBusy={isSubmitting || isBusy}
      />
      <CircularProgressButton
        fullWidth
        size="large"
        color="primary"
        type="submit"
        variant="contained"
        sx={{
          gap: tokens.spacingXs,
        }}
        disabled={!email.match(/^[a-zA-Z0-9_+-.]{1,64}@[a-zA-Z0-9-.]+\.[a-zA-Z]{2,63}$/)}
        isShowProgress={isSubmitting}
        data-action="continue-email"
      >
        Continue
      </CircularProgressButton>
    </Stack>
  );
}
